/**
 * Simple client-side rate limiter for auth forms.
 * Prevents rapid-fire submissions — Supabase handles server-side rate limiting.
 */

const attempts = new Map<string, { count: number; resetAt: number }>()

const WINDOW_MS = 60_000 // 1 minute
const MAX_ATTEMPTS = 5

/**
 * Check whether the action is rate-limited.
 * Returns `true` if the caller should proceed, or throws an error message if blocked.
 */
export function checkRateLimit(key: string): true {
  const now = Date.now()
  const entry = attempts.get(key)

  if (!entry || now >= entry.resetAt) {
    attempts.set(key, { count: 1, resetAt: now + WINDOW_MS })
    return true
  }

  if (entry.count >= MAX_ATTEMPTS) {
    const waitSec = Math.ceil((entry.resetAt - now) / 1000)
    throw new Error(`Too many attempts. Please wait ${waitSec}s and try again.`)
  }

  entry.count += 1
  return true
}
